import AiSceneCards from './AiSceneCards.vue'
import AiActionList from './AiActionList.vue'
import AiDeviceCards from './AiDeviceCards.vue'
import AiInfoList from './AiInfoList.vue'
// Deliberately non-recursive. New embedded types require a renderer and protocol validator.
// Existing registered types can be composed/labelled by the server without frontend changes.
export default Object.freeze({ action_list: AiActionList, device_cards: AiDeviceCards, scene_cards: AiSceneCards, info_list: AiInfoList })
